<div class="schedule-container">
  <div class="schedule-header">
    <p>Tarefas de hoje</p>
  </div>
  <div id="today-schedule-{{idx}}" class="schedule-item" [ngClass]="{'off': !ap.facColor, 'green': ap.facColor === 1, 'red': ap.facColor === 2, 'yellow': ap.facColor === 3 }" *ngFor="let ap of schedule; let idx = index">
    <div class="info">
      <p id="mark-name-{{idx}}">{{ ap.facName ? ap.facName : ap.title }}</p>
      <span id="mark-hour-{{idx}}">{{ ap.hourStart }}{{ ap.hourEnd ? ' até ' + ap.hourEnd : '' }}</span>
    </div>
    <div class="tag {{ ap.type }}">
      <div id="mark-type-{{idx}}" class="tag-item"><span>{{ ap.type | uppercase }}</span></div>
    </div>
  </div>
</div>